
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsPromoAvDaysDialog extends Serenity.EntityDialog<PsPromoAvDaysRow, any> {
        protected getFormKey() { return PsPromoAvDaysForm.formKey; }
        protected getIdProperty() { return PsPromoAvDaysRow.idProperty; }
        protected getLocalTextPrefix() { return PsPromoAvDaysRow.localTextPrefix; }
        protected getNameProperty() { return PsPromoAvDaysRow.nameProperty; }
        protected getService() { return PsPromoAvDaysService.baseUrl; }
        protected getDeletePermission() { return PsPromoAvDaysRow.deletePermission; }
        protected getInsertPermission() { return PsPromoAvDaysRow.insertPermission; }
        protected getUpdatePermission() { return PsPromoAvDaysRow.updatePermission; }

        protected form = new PsPromoAvDaysForm(this.idPrefix);

    }
}